import api from "../utils/api";
import { FilterSettingsModel } from "../common/models/CommonModels";
import { LocationModel, PersonModel, FilterInfo, DeletedReasonModel, CompanyDataModel, PhoneNumberModel, EmailModel } from "../common/models/CommonModels";
import * as moment from 'moment';
import { createFilterSettingsFilterUrl, createFilterUrl } from "./apiFilterUtils";
import { RecurrenceModel } from "../common/models/Recurrence";

const getEndpoint = "api/filterSettings";

type FilterSettingDto = FilterSettingsModel;

export const getFilterSettings = (companyId?: string): Promise<FilterSettingsModel[]> => {

    // `api/settings/user/${userId}`
    return api.get(`api/filterSettings?companyId=${companyId}`).then(response => {
        if (response.status === 200) {
            const data = <FilterSettingDto[]>response.data;
            return data.map(item => {
                return {
                    ...item,
                    validFrom: moment(item.validFrom),
                    validTo: moment(item.validTo)
                }
            });
        }

        return [];
    }).catch(error => {
        return [];
    });
}

export const addFilterSettings = (filter: FilterSettingsModel) => {
    const filterData = {
        ...filter,
        validFrom: moment(filter.validFrom).format(),
        validTo: moment(filter.validTo).format()
    }

    return api.post(getEndpoint, filterData).then(response => {
        if (response.status === 200) {
            return true;
        }

        return false;
    }).catch(error => {
        return false;
    });
}

export const editFilterSettings = (filter: FilterSettingsModel) => {

    const id = filter.id;

    const unitData = {
        ...filter,
        validFrom: moment(filter.validFrom).format(),
        validTo: moment(filter.validTo).format()
    }

    return api.put(`api/filterSettings/${id}`, unitData).then(response => {
        if (response.status === 200) {
            return true;
        }

        return false;
    }).catch(error => {
        return false
    });
}

export const deleteFilterSetting = (data: FilterSettingsModel) => {
    return api.post("api/filterSettings/delete", data).then(response => {
        if (response.status === 200) {
            return true;
        }

        return false;
    });
}


// WEBPACK FOOTER //
// ./src/api/filterSettingApi.ts